import React from 'react';
import rectangle from '../static/pictures/Loader_logos/Rectangle.png'
import H from '../static/pictures/Loader_logos/H.png'
//import "../static/css/loader.css"
    

function Loader() {
    return(
        <div className='Loader_body'>
            <div>
                <img src={rectangle} alt='logo' className='rect'/>
                <img src={H} alt='logo' className='h'/>
            </div>
        </div>
    );
}

export default Loader;